<template>
    <div :id="heroTextId" :class="[textAlign]">
        <p :id="heroTextId + '-eyebrow'" class="text-sm text-gray-500">
            {{ eyebrow }}
        </p>
        <h1 :id="heroTextId + '-header'" class="text-3xl font-bold">
            {{ header }}
        </h1>
        <p
            :id="heroTextId + '-body'"
            class="text-lg text-gray-500"
            v-html="body"
        ></p>
        <button
            :id="heroTextId + '-cta'"
            v-if="cta"
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 mt-4"
            @click="handleClick"
        >
            <a v-if="cta.link" :href="cta.link">{{ cta.text }}</a>
            <span v-else>{{ cta.text }}</span>
        </button>
    </div>
</template>

<script lang="ts" setup>
    import { computed } from "vue";
    import { type Cta } from "@interfaces/Cta";
    let { eyebrow, header, body, cta, textAlignment } = defineProps({
        // define the props that will be passed to the component
        eyebrow: {
            type: String,
            default: ""
        },
        header: String,
        body: String,
        cta: {
            type: Object as PropType<Cta>,
            default: null
        },
        textAlignment: {
            type: String,
            default: "center"
        }
    });

    let textAlign = computed(() => {
        return textAlignment === "center"
            ? "text-center"
            : textAlignment === "left"
              ? "text-left"
              : "text-right";
    });

    let heroTextId = computed(() => {
        return `hero-text-${eyebrow.replace(/\s/g, "-").toLowerCase()}`;
    });

    function handleClick() {
        if (cta && cta.onClick) {
            cta.onClick();
        }
    }
</script>
